exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.van-form[data-v-28ea689c]{width:7.56rem;margin:0 auto;margin-top:0.55rem\n}\n.van-form ul li[data-v-28ea689c]{border:1px solid rgba(161,161,161,0.26)\n}\n.van-form ul li+li[data-v-28ea689c]{margin-top:0.57rem\n}\n.van-form ul li>div[data-v-28ea689c]{padding:5px 16px\n}\n.van-form .btn[data-v-28ea689c]{width:100%;height:1.12rem;background:linear-gradient(182deg, #5cc4ff, #004eee);border-radius:0.2rem;border:none\n}\n.fixed[data-v-28ea689c]{position:fixed;width:100vw;height:100vh;left:0;top:0;background-color:#fff\n}\n", ""]);

// exports
